/**
 * Load CSS style Vendor
 */
import 'bootstrap-4-grid';

/**
 * Load Custom Styles
 */
import './lg-competition/assets/sass/main.sass';

/**
 * Load Custom JS
 */
import './lg-competition/assets/js/main.js';
import './lg-competition/assets/js/plugins/wpcf7.js';


/**
 * Load JS Vendor
 */
import 'jquery';
